export const brandMarkPaths = `
          <rect width="64" height="64" fill="#202020"/>
          <path data-brand-shape="triangle" d="M8 9H56L8 57Z" fill="#ffffff"/>`;

export const renderBrandMark = (className: string): string => `
        <svg class="${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
${brandMarkPaths}
        </svg>`;
